import React from 'react';
import * as _ from 'lodash';

import Table from '../../../../../facturotopia/table/Table';
import ConceptoTraslados from './impuestos-concepto/ConceptoTraslados';
import ConceptoRetenciones from './impuestos-concepto/ConceptoRetenciones';
import DecimalForConceptos from '../../../support/impuestos/DecimalForConceptos';
import ConceptoBaseCalculator from '../../../support/impuestos/ConceptoBaseCalculator';

const ConceptosNotEditableList = ({ data, onDelete, onEdit }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    const newData = data.filter((value) => item.id !== value.id);

    onDelete(newData);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  )
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: 'Cantidad',
    title: 'Cantidad',
    dataIndex: 'Cantidad',
  },
  {
    align: 'center',
    key: 'ClaveUnidad',
    title: 'Unidad',
    dataIndex: 'ClaveUnidad',
  },
  {
    key: 'Descripcion',
    title: 'Descripción',
    dataIndex: 'Descripcion',
  },
  {
    align: 'right',
    key: 'ValorUnitario',
    title: 'V. Unitario',
    dataIndex: 'ValorUnitario',
    render: (item) => DecimalForConceptos.make(item.ValorUnitario).toString()
  },
  {
    align: 'right',
    key: 'Impuestos',
    title: 'Impuestos',
    dataIndex: 'Impuestos',
    render: (item) => {
      return (
        <>
          <ConceptoTraslados data={ _.get(item, 'Impuestos.Traslados.Traslado') } />
          <ConceptoRetenciones data={ _.get(item, 'Impuestos.Retenciones.Retencion') } />
        </>
      );
    }
  },
  {
    align: 'right',
    key: 'Importe',
    title: 'Importe',
    dataIndex: 'Importe',
    render: (item) => {
      const base = ConceptoBaseCalculator.make(item).get();
      const total = DecimalForConceptos.make(base).toString();

      return (
        <span>
          { total }
          { parseFloat(item.Descuento || 0) > 0 && (
            <span>
              <br/>
              <br/>
              - { DecimalForConceptos.make(item.Descuento).toString() }
            </span>
          ) }
        </span>
      );
    }
  },
];

export default ConceptosNotEditableList;